import { useCallback, useState } from "react";
import type { AnnotationType, RGBA, ShapeKind } from "@modules/docs/annotations/types/TAnnotation";

const FALLBACK_SHAPE_COLOR: RGBA = "rgba(239, 68, 68, 1)";

const useAnnotationsVM = () => {
  const [activeTool, setActiveTool] = useState<AnnotationType>("shape");
  const [selectedShape, setSelectedShape] = useState<ShapeKind>("rectangle");
  const [selectedShapeColor, setSelectedShapeColor] =
    useState<RGBA>(FALLBACK_SHAPE_COLOR);

  const changeAnnotationTool = useCallback((tool: AnnotationType) => {
    setActiveTool(tool);
  }, []);

  const changeShape = useCallback((shape: ShapeKind) => {
    setSelectedShape(shape);
  }, []);

  const changeShapeColor = useCallback((color: RGBA) => {
    setSelectedShapeColor(color);
  }, []);

  return {
    activeTool,
    changeAnnotationTool,
    selectedShape,
    changeShape,
    selectedShapeColor,
    changeShapeColor,
  };
};

export default useAnnotationsVM;
